import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://fxqagvcgdrfnzmhxgcrt.supabase.co"
const supabaseKey = 'sb_publishable_AxYIpzMWXJBiD0mBDl28TA_noIvvLOD'

export const supabase = createClient(
  supabaseUrl,
  supabaseKey
)